/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
import { qreq } from "../shared/qrequest";
import L from "./Lang"
import BaseCom from "./BaseCom";
import Card from "./Card";
import Icon from "./Icon";
import Tick from "./Tick";

// todo: suggest based on utilization

export default class CPTCodeSelect extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            cptCodes: [],
            modCodes: []
        }
    }

    async componentDidMount() {
        await this.fillListAsync('/api/modcode/list', 'modCodes', true);
    }

    search = (e) => {
        if(!e.target.value) {
            this.setState({ cptCodes: [] });
            return;
        }
        qreq.post('/api/cptcode/list', { search: e.target.value }, j => {
            if(this.state.touched)
                return;
            if (j.list)
                this.setState({ cptCodes: j.list });
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    change = (e) => {
        this.setState({ touched: true, search: e.target.value });
    }

    tick = () => {
        if (this.state.touched) {
            this.setState({ touched: false });
            this.search({ target: { value: this.state.search } });
        }
    }

    select(i) {
        if (this.isSelected(i)) {
            this.props.item.cptCodes = this.props.item.cptCodes.filter(j => j.id !== i.id);
        } else {
            this.props.item.cptCodes = this.props.item.cptCodes ?? [];
            this.props.item.cptCodes.push(i);
        }
        this.props.onChange?.();
        this.props.onToggle?.();
    }

    isSelected(i) {
        if (this.props.item?.cptCodes?.find(j => j.id === i.id))
            return true;
        return false;
    }

    toggleAddMod = (i) => {
        i.add = !i.add;
        this.props.onToggle?.();
    }

    addModCode = (e, i) => {
        let find = i.modifiers?.find(j => j.id === parseInt(e.target.value));
        if(find) {
            i.add = false;
            this.props.onToggle?.();
            return; // already added
        }
        let mod = this.state.modCodes.find(j => j.id === parseInt(e.target.value));
        if (mod) {
            i.modifiers = i.modifiers ?? [];
            i.modifiers.push(mod);
            i.add = false;
            this.props.onToggle?.();
        }
    }

    removeModCode = (i, j) => {
        i.modifiers = i.modifiers.filter(a => a.id !== j.id);
        this.props.onToggle?.();
    }

    render() {
        return <Card title={this.props.title || 'CPT Codes'}>
            <Tick interval={1000} onTick={this.tick} />
            {!this.props.disabled && <input type="text" className="form-control mb-3" placeholder="Search CPT code or description..." onChange={this.change} />}
            {this.props.item?.cptCodes?.length === 0 ? <div className="text-muted"><L>No CPT Codes Selected</L></div> : <table className="table">
                <thead>
                    <tr>
                        <th><L>CPT</L></th>
                        <th className="d-none d-md-table-cell" style={{width: '50%'}}><L>Description</L></th>
                        {!this.props.hideModifiers && <th><L>Modifiers</L></th>}
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                        {this.props.item?.cptCodes?.map((i, idx) => (
                            <tr key={idx}>
                                <td>
                                    {i.code}
                                </td>
                                <td className="d-none d-md-table-cell text-muted">{i.description}</td>
                                {!this.props.hideModifiers && <td>
                                    <span>
                                    {i.modifiers?.length === 0 && !i.add && <span className="text-muted"><L>None</L></span>}
                                    {i.modifiers?.map((j, jdx) => (
                                        <span key={jdx} className="badge bg-secondary me-1 mb-1 no-select" title={j.description} data-tooltip-content={j.description}>
                                            {j.code} <Icon icon="faTimes" role="button" onClick={() => this.removeModCode(i, j)} />
                                        </span>
                                    ))}
                                    </span>
                                    {i.add && <div className="input-group">
                                        <select className="form-select" onChange={(e) => this.addModCode(e, i)}>
                                            <option value=""><L>Select Modifier</L></option>
                                            {this.state.modCodes.map((j, jdx) => !i.modifiers?.find(a => a.id === j.id)
                                                && <option key={jdx} value={j.id}>{j.code} - {j.description}</option>)}
                                        </select>
                                    </div>}
                                    {!i.add
                                        && this.state.modCodes.length > i.modifiers.length
                                        && !this.props.disabled
                                        && <span role="button" className="btn ms-md-2" onClick={() => this.toggleAddMod(i)}><Icon icon="faPlus" /></span>}
                                </td>}
                                <td className="text-end">
                                    {!this.props.disabled && <button type="button" className="btn btn-close" onClick={() => this.select(i)}></button>}
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>}
            {!this.props.disabled && this.state.cptCodes?.map((i, idx) => <div key={idx} className="border-bottom my-2">
                <div className="row align-items-center">
                    <div className="col-3 col-md-2 col-lg-2">
                        <button type="button" className={'btn w-100 ' + (this.isSelected(i) ? 'btn-success' : 'btn-primary')} onClick={() => this.select(i)}>{i.code}</button>
                    </div>
                    <div className="col-9 col-md-10 col-lg-10">
                        {i.description}
                    </div>
                </div>
            </div>)}
        </Card>;
    }
}